import { render, staticRenderFns } from "./KnFormActionButtons.vue?vue&type=template&id=aa909e52"
import script from "./KnFormActionButtons.vue?vue&type=script&lang=js"
export * from "./KnFormActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports